import { render, staticRenderFns } from "./InformationBoxView.vue?vue&type=template&id=22f53232&scoped=true"
import script from "../js/Information?vue&type=script&lang=js&external"
export * from "../js/Information?vue&type=script&lang=js&external"
import style0 from "./InformationBoxView.vue?vue&type=style&index=0&id=22f53232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f53232",
  null
  
)

export default component.exports